( function () {
	'use strict';
	/* eslint-disable max-params */
	function Schedules ( $scope, logger, calendarControl, scheduleservice, editschedservice, deleteschedservice, orderByFilter, createObsService, $q, $rootScope ) {
		var self = this;

		self.title = 'Schedules';

		// defaults
		self.fetching   = true;
		self.events     = [ ];
		self.navs       = [ 'Calendar', 'List' ];
		self.activeNav  = 0;
		self.viewMode   = 'calendar';
		self.search     = '';
		self.calControl = angular.extend( self, calendarControl );

		var preloadData = $q.all( [
			createObsService.getTemplates(),
			createObsService.getFavoriteTemplates(),
			createObsService.getSchoolsAndUsers()
		] );

		createObsService.savePreLoadedData( preloadData );

		function capitalize ( input ) {
			input = input.toLowerCase();
			return input.substring( 0, 1 ).toUpperCase() + input.substring( 1 );
		}

		function switchToListView () {
			self.activeNav = 1;
			self.viewMode  = 'events';
		}

		function updatePersistence ( val ) {
			if ( val ) {
				self.viewMode                = 'events';
				self.calControl.calendarView = 'list';
				return;
			}

			self.viewMode                = 'calendar';
			self.calControl.calendarView = 'month';
		}

		function startObsHandler ( schedule ) {
			scheduleservice.confirmStartObs( schedule );
		}

		function errorSchedules () {
			self.events   = [ ];
			self.fetching = false;
		}

		function filterDeletedEvent ( id ) {
			self.events = self.events.filter( function ( event ) {
				return event.id !== id;
			} );
		}

		function deleteEventModal ( event ) {
			if ( event.status === 'In Progress' ) {
				deleteschedservice.deleteObsModal( event.id )
					.then( function () {
						filterDeletedEvent( event.id );
					} );
			} else {
				deleteschedservice.openModal( event )
					.then( function () {
						filterDeletedEvent( event.id );
					} );
			}
		}

		function activate ( schedules ) {
			logger.info( 'Activated Schedules View' );

			$scope.$watch( 'vm.calControl.calendarView', function ( newVal ) {
				if ( newVal === 'month' ) {
					self.activeNav = 0;
					return;
				}

				self.activeNav = self.navs.indexOf( capitalize( newVal ) );
			} );

			// defaults
			self.events = orderByFilter( schedules, '+name' );
			self.events = orderByFilter( self.events, '+startDate' );

			self.fetching = false;

			$rootScope.$on( 'schedules:delete:event', function ( event, id ) {
				filterDeletedEvent( id );
			} );

			// handlers
			self.switchToListView   = switchToListView;
			self.updatePersistence  = updatePersistence;
			self.startObsHandler    = startObsHandler;
			self.editSchedHandler   = editschedservice.openModal;
			self.deleteSchedHandler = deleteEventModal;
		}

		scheduleservice.getSchedules()
			.then( activate, errorSchedules );
	}

	angular
		.module( 'app.schedules' )
		.controller( 'Schedules', Schedules );

	Schedules.$inject = [ '$scope', 'logger', 'calendarControl', 'scheduleservice', 'editschedservice', 'deleteschedservice', 'orderByFilter', 'createObsService', '$q', '$rootScope' ];
} )( );
